import type { BaseQueryFn } from "@reduxjs/toolkit/query";
import type { AxiosError, AxiosRequestConfig } from "axios";
import axiosPrivateClient from "./axiosPrivateClient";

export const privateBaseQuery =
  (): BaseQueryFn<
    {
      url: string;
      method: AxiosRequestConfig["method"];
      data?: AxiosRequestConfig["data"];
      body?: AxiosRequestConfig["data"];
      params?: AxiosRequestConfig["params"];
      headers?: AxiosRequestConfig["headers"];
      responseType?: AxiosRequestConfig["responseType"];
      timeout?: AxiosRequestConfig["timeout"];
    },
    unknown,
    unknown
  > =>
    async ({ url, method, data, body, params, headers, responseType, timeout }) => {
      try {
        const result = await axiosPrivateClient({
          url,
          method,
          data: body ?? data,
          params,
          headers,
          responseType,
          timeout,
        });
        return { data: result.data };
      } catch (error) {
        const err = error as AxiosError;
        const retryAfterHeader =
          typeof err.response?.headers?.get === "function"
            ? err.response.headers.get("retry-after")
            : err.response?.headers?.["retry-after"];

        return {
          error: {
            status: err.response?.status,
            data: err.response?.data || err.message,
            retryAfter: Array.isArray(retryAfterHeader)
              ? retryAfterHeader[0]
              : retryAfterHeader,
          },
        };
      }
    };
